import { useState, useEffect } from 'react';
import { Star } from 'lucide-react';
import { fetchReviewsForTarget, calculateReviewStats } from '../../services/reviewService';

export default function CourseReviewBadge({ courseId, showCount = true, className = '' }) {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    let isMounted = true;
    async function loadStats() {
      if (!courseId) return;
      const cacheKey = `__LOBAB_REVIEW_STATS_${courseId}`;
      if (window[cacheKey]) {
        if (isMounted) setStats(window[cacheKey]);
        return;
      }

      const reviews = await fetchReviewsForTarget(courseId);
      const calculated = calculateReviewStats(reviews);

      window[cacheKey] = calculated;
      if (isMounted) setStats(calculated);
    }
    loadStats();

    return () => { isMounted = false; };
  }, [courseId]);

  // Don't show if no reviews
  if (!stats || stats.total === 0) return null;

  return (
    <div className={`flex items-center gap-1 text-md font-bold text-slate-600 dark:text-slate-300 drop-shadow-sm transition-colors ${className}`}>
      <Star className="w-4 h-4 text-amber-500 dark:text-amber-400 fill-current" />
      <span className="mt-0.5">{stats.average.toFixed(1)}</span>
      {showCount && (
        <span className="text-md text-slate-400 dark:text-slate-500 font-medium tracking-wide">
          ({stats.total} {stats.total === 1 ? 'تقييم' : stats.total === 2 ? 'تقييمين' : stats.total <= 10 ? 'تقييمات' : 'تقييم'})
        </span>
      )}
    </div>
  );
}
